import NoopOnReconnectGateway from 'scripts/adapters/gateways/noop_on_reconnect_gateway';

export default class ExternalAppCardDataGateway extends NoopOnReconnectGateway {
  constructor(backend) {
    super(backend, {
      addUrl: '/api/v1/orgs/:orgId/external-app-card/data',
    });
  }

  requestData(params, payload, httpOptions) {
    return this.add(params, payload, httpOptions);
  }
}
